module.exports = __webpack_public_path__ + "img/qrcode-1810.4d377fb9.png";